import { ProjectCard } from "./ProjectCard";
import { formatPeriod } from "../lib/utils";

interface Project {
  period: {
    start: string;
    end: string | null;
  };
  title: string;
  technologies: {
    languages: string[];
    database: string[];
    os: string[];
    frameworks: string[];
  };
  phases: {
    requirement_definition: boolean;
    basic_design: boolean;
    detailed_design: boolean;
    implementation: boolean;
    integration_test: boolean;
    system_test: boolean;
    maintenance: boolean;
  };
  responsibilities: {
    tasks: string[];
    comment: string;
  };
  challenges: string;
  actions: string;
  achievements: string;
  team: {
    roles: Record<string, number>;
  };
}

interface WorkExperience {
  company: string;
  period: {
    start: string;
    end: string | null;
  };
  contract_type: string;
  role: string;
  duties: string;
  projects: Project[];
}

interface WorkHistoryProps {
  history: WorkExperience[];
}

export function WorkHistory({ history }: WorkHistoryProps) {
  return (
    <section>
      <h2 className="jp-heading break-after-avoid text-2xl print:text-xl font-black tracking-[0.04em] text-ink">
        職歴
      </h2>
      <div className="mt-6 print:mt-3 flex flex-col gap-16 print:gap-8">
        {history.map((experience, index) => (
          <article
            key={index}
            className="grid gap-x-10 gap-y-6 border-t-2 border-ink pt-6 lg:grid-cols-[15rem_1fr] print:block print:border-t-0 print:pt-0"
          >
            <header className="self-start break-inside-avoid break-after-avoid lg:sticky lg:top-8 print:mb-4 print:border-t-2 print:border-ink print:pt-4">
              <p className="text-[13px] font-medium tabular-nums text-accent">
                {formatPeriod(experience.period)}
              </p>
              <h3 className="jp-heading mt-1.5 print:mt-1 text-xl print:text-[17px] font-bold leading-snug text-ink">
                {experience.company}
              </h3>
              <dl className="mt-3 print:mt-1 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-[13px] leading-6 print:flex print:gap-x-2">
                <dt className="text-ink-3">役職</dt>
                <dd className="text-ink print:mr-4">{experience.role}</dd>
                <dt className="text-ink-3">雇用形態</dt>
                <dd className="text-ink">{experience.contract_type}</dd>
              </dl>
              <p className="mt-3 print:mt-1 whitespace-pre-line text-[13px] leading-6 text-ink-2">
                {experience.duties}
              </p>
            </header>

            <div className="flex flex-col print:block">
              {experience.projects.map((project, projectIndex) => (
                <ProjectCard key={projectIndex} project={project} />
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
